// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import Icon from './Icon';

type Props = {
  children: React.Node,
  isCorporate?: boolean,
};

export default function Label({
  children,
  isCorporate,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  return (
    <Base
      tagName="span"
      weight="semibold"
      flex
      flexAlignItemsCenter
      gap="xsmall"
      flexWrap
    >
      {children}
      {isCorporate && (
        <Icon
          name="badgeCorporate"
          theme="anthracite"
          title={__('badge corporate')}
        />
      )}
    </Base>
  );
}
